import { render, staticRenderFns } from "./Origen.vue?vue&type=template&id=cedcc342"
import script from "./Origen.vue?vue&type=script&lang=js"
export * from "./Origen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports